import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = 'omvedha_session_id';

export function getSessionId() {
  let s = localStorage.getItem(SESSION_KEY);
  if (!s) {
    s = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

export function getSource() {
  const params = new URLSearchParams(window.location.search);
  const src = params.get('src') || params.get('utm_source');
  if (src) return src.toLowerCase();
  const ref = document.referrer || '';
  if (/whatsapp|wa\.me/i.test(ref)) return 'whatsapp';
  if (ref) return 'referral';
  return 'direct';
}

export async function track(type, label = null) {
  try {
    await axios.post(`${API}/track`, {
      type,
      label,
      source: getSource(),
      path: window.location.pathname,
      referrer: document.referrer || null,
      session_id: getSessionId(),
    });
  } catch (e) {
    // analytics should never break the UX
  }
}
